import { lazy } from "react";

import { AuthRedirect } from "../pages";

export const routes = [
	{
		path: "/central",
		component: lazy(() =>
			import(/* webpackChunkName: "CentralPage" */ "../pages/CentralPage")
		),
		name: "CentralPage",
	},
	{
		path: "/auth-redirect",
		component: AuthRedirect,
		name: "AuthRedirect",
	},
	{
		path: "/waiting-room/:officeSlug/:lineSlug/:ticketId",
		component: lazy(() =>
			import(/* webpackChunkName: "WaitingRoom" */ "../pages/WaitingRoom")
		),
		name: "WaitingRoom",
	},
];
